import Container from "@components/shared/Container";
import Card from "@components/shared/Card";
import AddTransactionForm from "@components/form/transaction/AddTransactionForm";
import TransactionsTable from "@components/stat/transaction/table/TransactionsTable";
import TransactionReportButton from "@components/button/report/transaction/TransactionReportButton";

const TransactionsTab: React.FC = () => (
  <Container title="Управление транзакциями">
    <Card title="Добавить транзакцию" width="quarter">
      <AddTransactionForm />
    </Card>
    <Card>
      <TransactionReportButton />
      <TransactionsTable />
    </Card>
  </Container>
);

export default TransactionsTab;
